import { createRoot } from 'react-dom/client';

import Main from './server/js/Main';

import './server/css/app.css';

const root = createRoot(document.getElementById('root'));
root.render(<Main />);
